export default "__VITE_ASSET__C79AqDk$__"